export default class ContactFormController {
    constructor() {
        const element = document.getElementById('contactForm');

        if (element) {
            import(
                /* webpackChunkName: "ContactForm" */ "../classes/ContactForm"
            ).then(res => {
                const ContactForm = res.default;
                this.createInstance(ContactForm, element);
            });
        }
    }

    createInstance(ContactForm, element) {
        return new ContactForm(element);
    }
}


